module.exports = __webpack_public_path__ + "img/singapore-image-vector.55fc1c75.png";